import React, { useState } from 'react';

const MonthlyVehicleChecks = ({ setMonthlyChecks, allVehicles, fetchChecks, downloadData, downloadDefects, downloadReport, hasData, fetchedDate, fetchedVehicleId }) => {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [vehicle, setVehicle] = useState('all');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!month || !year) {
            setError('Please select both month and year.');
            return;
        }
        setError('');
        const selectedDate = `${year}-${month}`;
        setMonthlyChecks(selectedDate); // Set the selected date
        fetchChecks(selectedDate, vehicle); // Trigger the fetch function
    };

    const handleReportDownload = () => {
        downloadReport(fetchedDate, fetchedVehicleId || 'all');
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>

            {/* Select dropdown for vehicle */}
            <select
                value={vehicle}
                onChange={(e) => setVehicle(e.target.value)}
                style={{ padding: '5px', maxWidth: '110px' }}
            >
                <option value="all">All</option>
                {allVehicles.map((vehicle) => (
                    <option key={vehicle.id} value={vehicle.id}>
                        {vehicle.reg}
                    </option>
                ))}
            </select>

            {/* Select dropdown for month */}
            <select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                style={{ padding: '5px', width: '110px' }}
            >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, index) => {
                    const value = (index + 1).toString().padStart(2, '0');
                    return (
                        <option key={value} value={value}>
                            {new Date(0, index).toLocaleString('default', { month: 'long' })}
                        </option>
                    );
                })}
            </select>

            {/* Select dropdown for year */}
            <select
                value={year}
                onChange={(e) => setYear(e.target.value)}
                style={{ padding: '5px', width: '75px' }}
            >
                <option value="">Year</option>
                {Array.from({ length: 10 }, (_, index) => {
                    const value = new Date().getFullYear() - index;
                    return (
                        <option key={value} value={value}>
                            {value}
                        </option>
                    );
                })}
            </select>

            {/* Submit button */}
            <button
                className="hoverable"
                onClick={handleSubmit}
                style={{ padding: '5px 10px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
                Submit
            </button>

            {/* Download button */}
            {hasData && (
            <button
                className="hoverable"
                onClick={downloadData}
                style={{ padding: '5px 10px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
                Download
            </button>
            )}

            {/* Download Defects button */}
            {hasData && (
            <button
                className="hoverable"
                onClick={downloadDefects}
                style={{ padding: '5px 10px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
                Defects
            </button>
            )}

            {/* Report PDF button */}
            {hasData && (
            <button
                className="hoverable"
                onClick={handleReportDownload}
                style={{ padding: '5px 10px', backgroundColor: '#198754', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
                Report
            </button>
            )}

            </div>
            {error && <p style={{ color: 'red', margin: '6px 0 0 0' }}>{error}</p>}
        </div>
    );
};

export default MonthlyVehicleChecks;
